import { CircularProgress, Grid } from "@material-ui/core";

export const LoadingCircle = () => {
  return (
    <Grid container justifyContent="center" alignItems="center">
      <CircularProgress color="primary" />
    </Grid>
  );
};
